import React, { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  message: string;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Uygulama hatası:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-900 text-gray-100 flex items-center justify-center p-6">
          <div className="max-w-md text-center">
            <h1 className="text-xl font-bold mb-2">Sayfa yüklenemedi</h1>
            <p className="text-gray-400 text-sm mb-4">
              Tarayıcı önbelleğini temizleyip sayfayı yenileyin. Sorun devam ederse anasayfadan tekrar
              deneyin.
            </p>
            {this.state.message && (
              <p className="text-xs text-red-400/80 mb-4 font-mono break-all">{this.state.message}</p>
            )}
            <a
              href="/"
              className="inline-block px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-500"
            >
              Anasayfaya dön
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
